import * as CookieConsent from "vanilla-cookieconsent"

type ConsentCategory = "analytics" | "marketing" | "necessary"

export function hasConsented(category: ConsentCategory = "analytics"): boolean {
    try {
        return CookieConsent.acceptedCategory(category)
    } catch {
        return false
    }
}
